export default {
      id: "customer-experience-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#customer-experience",
      toString: function () {
        return this.url;
      }
    }